module.exports = __webpack_public_path__ + "static/media/Picture1.860ff5e1.png";